export default "/images/shildikStart.svg?5f18e675e6939f617cbf087c5b023b0f";